import { recolorRive } from 'src/app/shared/utils/rive-recolor.util';

/**
 * A paleta do `checklist-done.riv`, a animação de checklist concluído.
 *
 * O arquivo é gerado por script (`docs/rive/build_checklist_done.py` na raiz do monorepo), não pelo editor do
 * Rive, e por isso não tem view model: as cores moram em `SolidColor` no
 * binário e entram aqui pelos bytes, como no `document-stack.riv` da abertura.
 * Os índices são a ordem dos `SolidColor` no arquivo, que o gerador imprime ao
 * rodar. Os tiques (1, 6 e 11) ficam brancos nos dois temas: branco sobre verde.
 */
const SLOTS: ReadonlyArray<{ token: string; indexes: readonly number[]; fallback: number }> = [
    /** Nós cheios, trilha percorrida e a onda final. */
    { token: '--accentGreen', indexes: [0, 2, 7, 12, 16, 18], fallback: 0x15be78 },
    /** Miolo do anel pendente. */
    { token: '--backgroundPrimary', indexes: [3, 8, 13], fallback: 0xffffff },
    /** Borda do anel pendente. */
    { token: '--borderPrimary', indexes: [4, 9, 14], fallback: 0xd1d5db },
    /** As barras no lugar dos títulos. */
    { token: '--backgroundTertiary', indexes: [5, 10, 15], fallback: 0xe5e7eb },
    /** A trilha ainda não percorrida. */
    { token: '--borderSecondary', indexes: [17, 19], fallback: 0xe5e7eb },
];

/** Lê `#rgb` ou `#rrggbb` de uma variável do tema. */
function readToken(token: string, fallback: number): number {
    const raw = getComputedStyle(document.documentElement).getPropertyValue(token).trim();
    const hex = /^#([0-9a-f]{3}|[0-9a-f]{6})$/i.exec(raw)?.[1];
    if (!hex) return fallback;

    const full = hex.length === 3 ? hex.replace(/./g, ch => ch + ch) : hex;
    return parseInt(full, 16);
}

/** Devolve o arquivo com as cores do tema atual (claro ou escuro). */
export function paintChecklistDone(source: ArrayBuffer): ArrayBuffer {
    const colors = new Map<number, number>();

    for (const slot of SLOTS) {
        const argb = (0xff << 24) | readToken(slot.token, slot.fallback);
        for (const index of slot.indexes) colors.set(index, argb);
    }

    return recolorRive(source, colors);
}
